import { render, staticRenderFns } from "./ediotable.vue?vue&type=template&id=20436aec&scoped=true"
import script from "./ediotable.vue?vue&type=script&lang=js"
export * from "./ediotable.vue?vue&type=script&lang=js"
import style0 from "./ediotable.vue?vue&type=style&index=0&id=20436aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20436aec",
  null
  
)

export default component.exports